import { $post, $get, dealError } from "@/utils";
import store from "./index"
import { LOTTERY_CATEGORY } from "@/api"
let loading = false;
let reqTimes = 0;
const game = {
  state: {
    allGameList: [],
    hotGameList: [],
    gameCategoryList: []
  },
  getters: {
    AllGameList(state) {
      if (!state.allGameList.length) {
        store.dispatch("getGameList", { type: "all" });
      }
      return state.allGameList;
    },
    HotGameList(state) {
      if (!state.hotGameList.length) {
        store.dispatch("getGameList", { type: "hot" });
      }
      return state.hotGameList;
    },
    GameCategoryList(state) {
      if (!state.gameCategoryList.length) {
        store.dispatch("getGameCategory")
      }
      return state.gameCategoryList
    }
  },
  mutations: {
    SET_GAMELIST: (state, { type, data }) => {
      switch (type) {
        case "all":
          state.allGameList = data || [];
          break;
        case "hot":
          state.hotGameList = data || [];
          break;
        default:
          break;
      }
    },
    SET_GAME_CATEGORY: (state, data) => {
      state.gameCategoryList = data
    }
  },
  actions: {
    async getGameList({ commit }, payload = { type: "all" }) {
      if (loading) return;
      loading = true;
      return new Promise(async (resolve, reject) => {
        try {
          const { type } = payload;
          const { ret, msg, data } = await $get("/lottery/setting", {
            merchant_type: payload.type,
            lastinfo: 1,
          })
          commit("SET_GAMELIST", { type, data });
          loading = false;
          return resolve({ ret, data, msg });
        } catch (error) {
          loading = false;
          dealError(error);
          return reject(error);
        }
      })
    },
    getGameCategory({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await LOTTERY_CATEGORY();
          commit("SET_GAME_CATEGORY", res.data);
          return resolve(res);
        } catch (error) {
          return reject(error)
        }
      })
    }
  },
}
export default game
